import styled, { css } from 'styled-components';
import { DefaultText } from './GlobalText';
import { BorderColor, BorderColor2, DisabledColor, PrimaryColor, SurfaceColor } from './Utils';

export const INPUT_HEIGHT = 35;
export const INPUT_BORDER_RADIUS = '4px';

export const DefaultInput = css`
    ${DefaultText}
    box-sizing: border-box;
    height: ${INPUT_HEIGHT}px;
    padding: 0 10px;
    border: 1px solid ${BorderColor};
    border-radius: ${INPUT_BORDER_RADIUS};
    background-color: ${SurfaceColor};
    outline: none;

    &:focus, &:focus-visible {
        border-color: ${PrimaryColor};
        outline: none;
    }

    &:disabled {
        background-color: color-mix(in oklab, ${DisabledColor}, ${SurfaceColor} 50%);
        cursor: not-allowed;
    }

    &::placeholder {
        color: ${BorderColor2};
        opacity: 1;
    }
`;

export const DefaultInputBlock = styled.input`
    ${DefaultInput}
`;
